import React from 'react';
import type { GlueIntegration } from '@glueapp/graph-types';
import { isOAuthIntegration, isOktaIntegration } from '@glueapp/graph-types';
import { OktaIntegrationAuthForm } from './OktaIntegrationAuthForm';
import { OAuthIntegrationAuthForm } from './OAuthIntegrationAuthForm';

interface Props {
    integration: GlueIntegration<any>;
    label: string;
}

export const IntegrationAuthorizer: React.FC<Props> = ({ integration, label }) => {
    if (isOktaIntegration(integration)) {
        return <OktaIntegrationAuthForm integration={integration} label={label} />;
    } else if (isOAuthIntegration(integration)) {
        return <OAuthIntegrationAuthForm integration={integration} label={label} />;
    }

    return null;
};
